// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2ZMdY","header":"MergedInvoice_header__2vIEy"};